// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.methanol-chart-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    overflow: auto hidden;
    padding-bottom: 42px;
    scrollbar-color: #c8c8c8 #f2f2f2;
    scrollbar-color: #c8c8c8 var(--background-subtle, #f2f2f2);
    scrollbar-width: thin;
    opacity: 1;
}

.methanol-chart-scroll::-webkit-scrollbar {
    background: #f2f2f2;
    background: var(--background-subtle, #f2f2f2);
    width: 4px;
    height: 4px;
    opacity: 1;
}

.methanol-chart-scroll::-webkit-scrollbar-track {
    background: #f2f2f2;
    background: var(--background-subtle, #f2f2f2);
    border-radius: 999px;
}

.methanol-chart-scroll::-webkit-scrollbar-thumb {
    background: #ccc;
    background: var(--content-knockout-subtle-hover, #ccc);
    border: 0;
    border-radius: 2px;
    box-shadow: 0 0 2px 0 #fff;
    min-width: 40px;
    opacity: 1;
}

.methanol-chart-scroll::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
}

.methanol-chart-scroll::-webkit-scrollbar-thumb:hover {
    background: #ccc;
    background: var(--content-knockout-subtle-hover, #ccc);
}
`, "",{"version":3,"sources":["webpack://./src/components/MethanolCharts/MethanolChart.css"],"names":[],"mappings":"AAAA;IACI,gBAAqB;IAArB,kBAAqB;IAArB,qBAAqB;IACrB,oBAAoB;IACpB,gCAA0D;IAA1D,0DAA0D;IAC1D,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,mBAA6C;IAA7C,6CAA6C;IAC7C,UAAU;IACV,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAA6C;IAA7C,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,gBAAsD;IAAtD,sDAAsD;IACtD,SAAS;IACT,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,gBAAsD;IAAtD,sDAAsD;AAC1D","sourcesContent":[".methanol-chart-scroll {\n    overflow: auto hidden;\n    padding-bottom: 42px;\n    scrollbar-color: #c8c8c8 var(--background-subtle, #f2f2f2);\n    scrollbar-width: thin;\n    opacity: 1;\n}\n\n.methanol-chart-scroll::-webkit-scrollbar {\n    background: var(--background-subtle, #f2f2f2);\n    width: 4px;\n    height: 4px;\n    opacity: 1;\n}\n\n.methanol-chart-scroll::-webkit-scrollbar-track {\n    background: var(--background-subtle, #f2f2f2);\n    border-radius: 999px;\n}\n\n.methanol-chart-scroll::-webkit-scrollbar-thumb {\n    background: var(--content-knockout-subtle-hover, #ccc);\n    border: 0;\n    border-radius: 2px;\n    box-shadow: 0 0 2px 0 #fff;\n    min-width: 40px;\n    opacity: 1;\n}\n\n.methanol-chart-scroll::-webkit-scrollbar-button {\n    display: none;\n    height: 0;\n    width: 0;\n}\n\n.methanol-chart-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--content-knockout-subtle-hover, #ccc);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
